import { observer } from 'mobx-react-lite';
import queryString from 'query-string';
import React, { useContext, useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Container } from 'semantic-ui-react';

import { history } from '../..';
import LoadingComponent from '../../app/layout/LoadingComponent';
import BmsgLoginComponent from '../../app/layout/BmsgLoginComponent';
import { LoginValuesEmailPassword } from '../../app/models/login';
import { RootStoreContext } from '../../app/stores/rootStore';

const BmsgAuth: React.FC<RouteComponentProps> = ({ location }) => {
  const rootStore = useContext(RootStoreContext);
  const { setSession } = rootStore.sessionStore;
  const { loginBmsgAuth, getBmsgAuth } = rootStore.memberStore;
  const { client_id, callback_url, auth_params, fanclub, id_text, pass_text } = queryString.parse(location.search);

  const [appLoaded, setAppLoaded] = useState(false);
  const [sessionId, setSessionId] = useState('');
  const [code, setCode] = useState('');

  const [formValues, setFormValues] = useState(new LoginValuesEmailPassword());
  const [select_option, setSelectOption] = useState<{ key: number; value: string; text: string }[]>([]);
  useEffect(() => {
    try {
      (async () => {
        // セッション保持
        const session = await setSession({
          session_id: '',
          client_id: client_id as string,
          auth_params: auth_params as string,
          callback_url: callback_url as string,
        });
        setSessionId(session.session_id);
        setAppLoaded(true);
        const bmsg_auth = await getBmsgAuth(session.client_id, session.auth_params);
        const code_list = [
          {
            code: 'befirst',
            value: 'BESTY（BE:FIRST）',
          },
          {
            code: 'mazzel',
            value: 'MUZEUM（MAZZEL）',
          },
          {
            code: 'starglow',
            value: 'STARS（STARGLOW）',
          },
          {
            code: 'skyhi',
            value: 'FLYERS（SKY-HI）',
          },
          {
            code: 'novelcore',
            value: 'CORE HOUSE（Novel Core）',
          },
          {
            code: 'ats',
            value: 'Aile The Shota fanclub',
          },
          {
            code: 'reiko',
            value: 'R&Me（REIKO）',
          },
          {
            code: 'edhiiiboi',
            value: 'CeNTeR（Edhiii boi）',
          },
          {
            code: 'hana',
            value: 'HANA Official Fan Club',
          },
          {
            code: 'ayumuimazu',
            value: 'Ayumu Imazu Official Fan Club',
          },
          {
            code: 'fumino',
            value: 'ふみの Official Fan Club',
          },
          {
            code: 'b-town',
            value: 'B-Town',
          },
          {
            code: 'b-town_a',
            value: 'B-Town（Architect）',
          },
          {
            code: 'b-town_r',
            value: 'B-Town（Resident）',
          },
        ];
        const matchedCode = code_list.find((item) => item.code === bmsg_auth.code);
        const matchedValue = matchedCode ? matchedCode.value : '';
        if (matchedCode) {
          setCode(matchedValue);
        }
        const bTownOptions = [
          { value: 'B-Town（Architect）', text: 'B-Town（Architect）' },
          { value: 'B-Town（Resident）', text: 'B-Town（Resident）' },
        ];
        if (bmsg_auth.code === 'bmsg_fes') {
          const bmsgFesCodeList = code_list.filter(
            (item) => item.code !== 'edhiiiboi' && !item.code.startsWith('b-town'),
          );
          setSelectOption(
            [
              ...bmsgFesCodeList.map((item) => ({ value: item.value, text: item.value })),
              ...bTownOptions,
            ].map((item, i) => ({ key: i + 1, ...item })),
          );
        } else if (bmsg_auth.code === 'b-town') {
          setSelectOption(
            bTownOptions.map((item, i) => ({
              key: i + 1,
              ...item,
            })),
          );
        } else if (bmsg_auth.code === 'b-town_a') {
          setSelectOption([{ ...bTownOptions[0], key: 1 }]);
        } else if (bmsg_auth.code === 'b-town_r') {
          setSelectOption([{ ...bTownOptions[1], key: 1 }]);
        } else {
          setSelectOption(
            [{ value: matchedValue, text: matchedValue }, ...bTownOptions].map((item, i) => ({
              key: i + 1,
              ...item,
            })),
          );
        }
      })();
    } catch (error) {
      history.push('/error');
    }
  }, [auth_params, callback_url, client_id, setSession]);

  if (!appLoaded) return <LoadingComponent content="Loading..." />;

  let invalidCredentialsMessage = '';
  if (id_text) {
    invalidCredentialsMessage += `${id_text}または`;
  } else {
    invalidCredentialsMessage += 'メールアドレスまたは';
  }
  if (pass_text) {
    invalidCredentialsMessage += `${pass_text}が正しくありません。`;
  } else {
    invalidCredentialsMessage += 'パスワードが正しくありません。';
  }

  return (
    <Container>
      <BmsgLoginComponent
        title=""
        description={
          fanclub
            ? `${fanclub}`
            : '認証するファンクラブを選択のうえ、</br>メールアドレスとパスワードで認証してください。'
        }
        emailPlaceholder={pass_text ? `${pass_text}` : 'メールアドレス'}
        passwordPlaceholder={id_text ? `${id_text}` : 'パスワード'}
        invalidCredentialsMessage={invalidCredentialsMessage}
        userlockedMessage="アカウントがロックされました。時間を空けてから再度お試しください。"
        formValues={formValues}
        setFormValues={setFormValues}
        select_options={select_option}
        handleAuthenticate={async () => {
          // 認証先のパラメータを設定
          const { ...values } = formValues;
          values.session_id = sessionId;
          values.client_id = client_id as string;
          values.auth_params = auth_params as string;
          // 認証
          await loginBmsgAuth(values);
        }}
      />
    </Container>
  );
};

export default observer(BmsgAuth);
